import * as React from 'react'
import './index.scss'
import {connect} from "react-redux";
import LinkFilters from "./LinkFilters";
import {
    ActionType, CHAINTYPES, reducerStoreType, ROLES
} from "../../reducers/types";
import {Dispatch} from "redux";
import History from './History'
import Pagination from "../../components/Pagination";

interface IProps{
    dispatch: Dispatch<ActionType<any>>,
    total: number,
    recordsPerPage: number,
    currentPage: number,
    chainType: CHAINTYPES,
    role: ROLES,
}
class ExchangeRecords extends React.Component<IProps, {}> {
    
	onPageChange = (page: number) =>{
        this.props.dispatch({type: 'SET_PAGE_INDEX', payload: {currentPage: page}})
    }
    onRecordsPerPageChange = (value: number) =>{
        this.props.dispatch({type: 'SET_PAGE_SIZE', payload: {recordsPerPage: value, currentPage: 1}})
    }
    public render() {
        return (
            <div className="orders">
                <LinkFilters/>
                <History/>
                <Pagination total={this.props.total}
                            currentPage={this.props.currentPage}
                            recordsPerPage={this.props.recordsPerPage}
                            onPageChange={this.onPageChange}
                            onRecordsPerPageChange={this.onRecordsPerPageChange}/>
            </div>
        );
    }
}

export default connect((state: reducerStoreType) => {
    return {
        total: state.exchangeRecords.RecordsInfo.total,
        recordsPerPage: state.exchangeRecords.RecordsFilters.recordsPerPage,
        currentPage: state.exchangeRecords.RecordsFilters.currentPage,
        chainType: state.merchant.merchantInfo.chainType,
        role: state.app.userInfo ? state.app.userInfo.role : ROLES.NONE
    }
})(ExchangeRecords)
